import Vibrant from "node-vibrant";
import camelCase from "lodash.camelcase";

/*
export type PaletteColors = {
  vibrant?: string;
  muted?: string;
  darkVibrant?: string;
  darkMuted?: string;
  lightVibrant?: string;
  lightMuted?: string;
  [name: string]: string | undefined;
};
*/
export async function getPalette(src) {
console.log("getPalette",src)
  const palette = await Vibrant.from(src).getPalette();
  console.log("palette", palette)

  const hexPalette = Object.keys(palette).reduce(function (previous, key) {
    return {...previous, [camelCase(key)]:palette[key].hex}
}, 0);
  
  return hexPalette;
  
}

export function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}


export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


/*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */
var getContrast = function (hexcolor){

	// If a leading # is provided, remove it
	if (hexcolor.slice(0, 1) === '#') {
		hexcolor = hexcolor.slice(1);
	}

	// If a three-character hexcode, make six-character
	if (hexcolor.length === 3) {
		hexcolor = hexcolor.split('').map(function (hex) {
			return hex + hex;
		}).join('');
	}

	// Convert to RGB value
	var r = parseInt(hexcolor.substr(0,2),16);
	var g = parseInt(hexcolor.substr(2,2),16);
	var b = parseInt(hexcolor.substr(4,2),16);

	// Get YIQ ratio
	var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return (yiq >= 128) ? 'black' : 'white';

};

export function contrastHex(hexcolor){

	// If a leading # is provided, remove it
	if (hexcolor.slice(0, 1) === '#') {
		hexcolor = hexcolor.slice(1);
	}

	// If a three-character hexcode, make six-character
	if (hexcolor.length === 3) {
		hexcolor = hexcolor.split('').map(function (hex) {
			return hex + hex;
		}).join('');
	}

	// Convert to RGB value
	var r = parseInt(hexcolor.substr(0,2),16);
	var g = parseInt(hexcolor.substr(2,2),16);
	var b = parseInt(hexcolor.substr(4,2),16);

	// Get YIQ ratio
	var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return yiq;

};
/*
export function contrastRgb(rgbcolor){


	// Convert to RGB value
	var r = rgbcolor.r
	var g = rgbcolor.g
	var b = rgbcolor.b

	// Get YIQ ratio
	var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return yiq;

};
*/

export function setContrast(hexColor, refHexColor, contrastSetting ) {
console.log("hexColor",hexColor)
console.log("refHexColor",refHexColor)
 // var refContrast = contrastHex(refHexColor);
 var refRgb = hexToRgb(refHexColor)
  var rgb = hexToRgb(hexColor)
console.log("Start RGB")
console.log(rgb)
  var multiplier = 1;
  var multiplierAdjustment = 0.05;
  var count = 0;
  while(count < 10) {
    count += 1;
    // Adjust rbg
    var r = rgb.r * multiplier;
    var g = rgb.g * multiplier;
    var b = rgb.b * multiplier;

    rgb = {r:r,g:g,b:b};

    console.log("---" + rgb.r + " " + rgb.g + " " + rgb.b)

    var contrastRatio = contrastRGB(rgb, refRgb)
    if (contrastRatio < previousContrastRatio) {multiplierAdjustment = -multiplierAdjustment}

  
console.log("contrastRatio", contrastRatio)
    if (contrastRatio > contrastSetting) {
      break;}
    multiplier = multiplier + multiplierAdjustment;
var previousContrastRatio = contrastRatio;

  }
console.log("End RGB")
  console.log(rgb)
return rgbToHex(rgb.r,rgb.g,rgb.b);
}

export function contrastHexColours(hexcolorA, hexcolorB) {

var contrastA = contrastHex(hexcolorA);
var contrastB = contrastHex(hexcolorB)

return contrastA/contrastB;

}

export function luminanceRGB(r, g, b) {
  var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928
          ? v / 12.92
          : Math.pow( (v + 0.055) / 1.055, 2.4 );
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
export function contrastRGB(rgb1, rgb2) {
  var lum1 = luminanceRGB(rgb1.r, rgb1.g, rgb1.b);
  var lum2 = luminanceRGB(rgb2.r, rgb2.g, rgb2.b);
  var brightest = Math.max(lum1, lum2);
  var darkest = Math.min(lum1, lum2);
  return (brightest + 0.05)
       / (darkest + 0.05);
}
//contrast([255, 255, 255], [255, 255, 0]); // 1.074 for yellow
//contrast([255, 255, 255], [0, 0, 255]); // 8.592 for blue
// minimal recommended contrast ratio is 4.5, or 3 for larger font-sizes